import { IntegrationTypeCardWebComponent } from './component/IntegrationTypeCardWebComponent';
import { WEB_COMPONENT_INTEGRATION_TYPE_CARD } from '../../webcomponents.constants';

export { IntegrationTypeCardWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRATION_TYPE_CARD, IntegrationTypeCardWebComponent);
